var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripe2 = function SvgStripe2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 123 188",
    preserveAspectRatio: "xMaxYMax meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144 246c-16.957-70.274-87.373-87.514-106.67-100.195-19.296-12.68-28.907-26.612-23.117-40.631 5.79-14.02 21.431-7.983 35.711 3.443 14.28 11.425 48.203 62.081 63.659 37.705 2.831-4.465 3.583-9.286 3.56-13.221-.033-5.503-1.119-11.045-2.442-16.387-1.029-4.157-2.898-9.64-6.294-15.845C100.853 87.063 76.34 42.389 7 7",
    stroke: "url(#stripe-2_svg__a)",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe-2_svg__a",
    x1: 109.157,
    y1: 74.926,
    x2: 78.829,
    y2: 243.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#789EC4"
  })))));
};
export default SvgStripe2;